import React from 'react';
import { KbHomePage } from '../../../content/types/content/kb-home';

const KbHome = (props: { entry: KbHomePage }) => {
    const { entry: {title, subtitle, url, id} } = props;
    return (
        <>
            <h1>{title}</h1>
            <h2>{subtitle}</h2>
            <div>Viewing KB home with id {id} in the {url} space</div>
        </>
    );
};

export default KbHome;
